import(/* webpackMode: "eager" */ "/app/apps/dashboard/src/app/global-error.tsx");
